import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { companyLogoUrl } from "../../../apis/company-logo-apis/companyLogoApis";

// Integration logos are a file name on the logos CDN. A logo uploaded for a
// vendor added by hand is a path on the customer file CDN ("<id>/trust-center/vendors/…").
export const vendorLogoUrl = (logoPath) => {
  if (!logoPath) return null;
  if (String(logoPath).includes("/")) return companyLogoUrl(logoPath);
  return `${process.env.REACT_APP_POLICY_DOC_URL}/logos/${encodeURIComponent(logoPath)}`;
};

// A subprocessor's logo, or the vendor's first letter when there is none.
const VendorLogo = ({ name, logoPath, size = 28 }) => {
  const theme = useTheme();
  const [failedUrl, setFailedUrl] = useState(null);
  const url = vendorLogoUrl(logoPath);
  const tile = {
    width: size,
    height: size,
    flexShrink: 0,
    borderRadius: `${Math.round(size * 0.25)}px`,
    border: `1px solid ${theme.customColors.border.main}`,
    backgroundColor: theme.customColors.background.cardHeader,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    boxSizing: "border-box",
  };

  if (url && failedUrl !== url) {
    return (
      <Box sx={tile} aria-hidden="true">
        <Box
          component="img"
          src={url}
          alt=""
          onError={() => setFailedUrl(url)}
          sx={{
            width: "72%",
            height: "72%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </Box>
    );
  }
  return (
    <Box sx={tile} aria-hidden="true">
      <Box
        component="span"
        sx={{
          fontWeight: 600,
          fontSize: Math.round(size * 0.45),
          color: theme.customColors.text.secondary,
          lineHeight: 1,
        }}
      >
        {(name || "?").trim().charAt(0).toUpperCase()}
      </Box>
    </Box>
  );
};

export default VendorLogo;
